import { FiUser } from "react-icons/fi";
import { MdAnalytics, MdDashboard, MdHouse, MdManageHistory, MdPayments, MdReport } from "react-icons/md";
import { HiUserGroup } from "react-icons/hi";
import {FaBuilding, FaHouseUser, FaReceipt} from "react-icons/fa"
import {BsFillHouseAddFill} from "react-icons/bs"
export const SidebarUpContent = [
	{
		icon: <MdDashboard className="h-5 w-5"/>,
		actionIcon: <MdDashboard className="text-primary h-5 w-5"/>,
		title: 'Dash Board',
		urlRoots: ['dashboard'],
		url: '/dashboard',
	},
	{

		icon: (
		<FaBuilding className="h-5 w-5"/>
		),
		actionIcon: <FaBuilding className="text-primary h-5 w-5"/>,

		title: 'Apartments',
		urlRoots: ['apartments'],
		url: '/Apartments',
	},
	{
		icon: (
			<BsFillHouseAddFill className="h-5 w-5"/>
		),
		actionIcon: <BsFillHouseAddFill className="text-primary h-5 w-5"/>,

		title: 'Properties',
		urlRoots: ['properties'],
		url: '/properties',
	},
	{
		icon: (
			
			<FaHouseUser className="h-5 w-5"/>
		),
		actionIcon: <FaHouseUser className="text-primary h-5 w-5"/>,

		title: 'Tenants',
		urlRoots: ['tenents'],
		url: '/tenents',
	},
{
		icon: (
			<MdPayments className="h-5 w-5"/>
		),
		actionIcon: <MdPayments className="text-primary h-5 w-5"/>,

		title: 'Payments',
		urlRoots: ['payments'],
		url: '/payments',
	},
	{
		icon: (
			<FaReceipt className="h-5 w-5"/>
		),
		actionIcon: <FaReceipt className="text-primary h-5 w-5"/>,

		title: 'Expenses',
		urlRoots: ['expenses'],
		url: '/expenses',
	},


		{
		icon: (
		<HiUserGroup className="h-5 w-5"/>
		),
		actionIcon: <HiUserGroup className="text-primary h-5 w-5"/>,

		title: 'Users',
		urlRoots: ['users'],
		url: '/users',
	},

	{

		icon: (
		<MdManageHistory className="h-5 w-5"/>
		),
		actionIcon: <MdManageHistory className="text-primary h-5 w-5"/>,

		title: 'Reports',
		urlRoots: ['payment-history'],
		url: '/payment-history',
	},

		
	
	
];

export const SidebarUpContentForPaymentCollector = [
	{
		icon: <MdDashboard className="h-5 w-5"/>,
		actionIcon: <MdDashboard className="text-primary h-5 w-5"/>,
		title: 'Dash board',
		urlRoots: ['dashboard'],
		url: '/dashboard',
	},
	{
		icon: (
			<BsFillHouseAddFill className="h-5 w-5"/>
		),
		actionIcon: <BsFillHouseAddFill className="text-primary h-5 w-5"/>,

		title: 'Properties',
		urlRoots: ['properties'],
		url: '/properties',
	},
	{
		icon: (
			
			<FaHouseUser className="h-5 w-5"/>
		),
		actionIcon: <FaHouseUser className="text-primary h-5 w-5"/>,

		title: 'Tenents',
		urlRoots: ['tenents'],
		url: '/tenents',
	},
{
		icon: (
			<MdPayments className="h-5 w-5"/>
		),
		actionIcon: <MdPayments className="text-primary h-5 w-5"/>,

		title: 'Payments',
		urlRoots: ['payments'],
		url: '/payments',
	},
	
	{
		icon: (
			<FaReceipt className="h-5 w-5"/>
		),
		actionIcon: <FaReceipt className="text-primary h-5 w-5"/>,

		title: 'Expenses',
		urlRoots: ['expenses'],
		url: '/expenses',
	},
	
];